// extracted by mini-css-extract-plugin
export var content = "_p2-1";
export var fullScreen = "_p2-0";